module.exports = __webpack_public_path__ + "img/google.db4c34e0.png";